export const SENTRY_TRACE_PROPAGATION_TARGETS: Array<string> = [
  "localhost",
  "https://dragon-api.vidlet.io",
  "https://dragon-api.vidletstage.io",
  "https://dragon-api.vidletdev.io",
  "https://dragon-api-sandbox.vidletdev.io",
];

export const SENTRY_NETWORK_DETAIL_ALLOW_URLS: Array<RegExp> = [
  /https:\/\/dragon-api\.vidlet(stage|dev)?\.io\/api\/.*/,
  /https:\/\/dragon-api-sandbox\.vidletdev\.io\/api\/.*/,
];

export type SentryRuntimeConfig = {
  dsn: string;
  environment?: string;
  release?: string;
};

export function getSentryRuntimeConfig(): SentryRuntimeConfig | null {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    return null;
  }
  return {
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    release: process.env.REACT_APP_SENTRY_RELEASE,
  };
}
